"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = void 0;
exports.path = '/service-center-gateway-reposition';
//# sourceMappingURL=index.js.map